import $ from 'jquery';
import 'popper.js';
import 'bootstrap';
import '@fortawesome/fontawesome-free';
import $script from 'scriptjs';

window.$ = $;
window.jQuery = $


//Import Modules
import googleApi from './modules/googleApi.js';
import timesheetTable from './modules/timesheetTable.js';
import projects from './modules/projects.js';

const FormAddProject = $("form.form-add-project");


$script.get('https://apis.google.com/js/platform.js', function () {
	googleApi.renderButton();
	googleApi.init();

	if(FormAddProject.length){
		projects.init();
	}
	
})


//Run Modules
timesheetTable.init();


// HMR Setup
if (module.hot) {
	module.hot.accept(() => {
		// or use this instead of dispose()
		// window.location.reload();
	});

	module.hot.dispose(() => {
		window.location.reload();
	});
}

let getName = localStorage.getItem('getName');

$(document).ready(function() {
	$('#staffName').text(getName);
});



